import moment from 'moment';
import { FormsConstants } from '../types/forms-constants';

export namespace DateUtilities {
    export const getDayMonthYearValuesFromDateString = (
        d: string,
    ): {
        day: string;
        month: string;
        year: string;
    } => {
        const newDate = d.length > 0 && d !== FormsConstants.NA ? moment(d) : moment.invalid();

        // The  format is specified in the xml file by the `MAXCHARS` attribute
        // we d ecided to hard-code it here. In case format changes are required,
        // we s hould react to the `MAXCHARS` attribute.
        const day = newDate.isValid() ? newDate.format('DD') : FormsConstants.NA;
        const month = newDate.isValid() ? newDate.format('MMM') : FormsConstants.NA;
        const year = newDate.isValid() ? newDate.format('YYYY') : FormsConstants.NA;
        return {
            day,
            month,
            year,
        };
    };
}
